import { LetterStep, letterStore } from "src/js/stores/letter/store";
import React, { useEffect } from "react";

import { ConfirmAndSendStep } from "./ConfirmAndSendStep/ConfirmAndSendStep";
import { DownloadLetterStep } from "./DownloadLetterStep/DownloadLetterStep";
import { LetterPreviewStep } from "./LetterPreviewStep";
import { OrderConfirmedStep } from "./OrderConfirmedStep";
import ROUTES from "src/js/router/routes";
import { SelectEditableRecipientsStep } from "./SelectEditableRecipientsStep";
import { TemplateEditorStep } from "./TemplateEditorStep";
import { router } from "src/js/router/react-router";
import { useSnapshot } from "valtio";

export const Letters = () => {
  const { currentStep, selectedStageIds, selectedSiteIds } = useSnapshot(letterStore);

  useEffect(() => {
    if (!selectedSiteIds?.length && !selectedStageIds?.length) {
      router.push({
        name: ROUTES.SITES,
        query: {
          card_page: "letters",
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ActiveLetterStep = () => {
    switch (currentStep) {
      case LetterStep.FinishAndDownload:
        return <DownloadLetterStep />;
      case LetterStep.SelectRecipients:
        return <SelectEditableRecipientsStep />;
      case LetterStep.TemplateEditor:
        return <TemplateEditorStep />;
      case LetterStep.PreviewLetter:
        return <LetterPreviewStep />;
      case LetterStep.ConfirmAndSend:
        return <ConfirmAndSendStep />;
      case LetterStep.OrderConfirmed:
        return <OrderConfirmedStep />;
      default:
        return <React.Fragment />;
    }
  };

  return (
    <div className="w-svw h-full">
      <ActiveLetterStep />
    </div>
  );
};
